/* eslint-disable react/destructuring-assignment, react/no-access-state-in-setstate */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { Component } from 'react'

import { SecondaryButton } from '../Button/SecondaryButton'

const styles = theme => ({
  wrapper: {
    display: 'block',
    width: '100%',
    backgroundColor: `var(--gameday-questions-questionAdvancedBg, ${theme.questions.questionAdvancedBg})`,
    border: `1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`}`,
    borderRadius: '4px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 15,
    '& h4': {
      margin: '0 0 0 18px',
      fontSize: theme.typography.fontSizeMedish,
      fontWeight: theme.typography.fontWeightBolder,
      color: `var(--gameday-body-textColorDark, ${theme.body.textColorDark})`,
    },
  },
  content: {
    borderTop: `1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`}`,
    padding: '15px',
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-body-textColor, ${theme.body.textColor})`,
  },
  button: {
    backgroundColor: `var(--gameday-buttons-backButtonBg, ${theme.buttons.backButtonBg})`,
  },
})

class QuestionAdvanced extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  render() {
    const { children, classes, title, className } = this.props

    const toggleOpen = () => {
      this.setState({
        open: !this.state.open,
      })
    }

    return (
      <div className={cn(classes.wrapper, className)}>
        <header className={classes.header}>
          <h4>{title}</h4>
          <SecondaryButton
            className={classes.button}
            onClick={toggleOpen}
            // size="small"
            aria-label={this.state.open ? 'Close' : 'Expand'}
          >
            {this.state.open ? 'Close' : 'Expand'}
          </SecondaryButton>
        </header>
        {this.state.open && (
          <div className={classes.content}>
            <div>{children}</div>
          </div>
        )}
      </div>
    )
  }
}

QuestionAdvanced.defaultProps = {
  title: 'Advanced Options',
}

const QuestionAdvancedComponent = withStyles(styles)(QuestionAdvanced)
QuestionAdvancedComponent.displayName = 'QuestionAdvanced'
export default QuestionAdvancedComponent
